<div red-navbar [attr.background]="background" [attr.redShape]="redShape" [attr.redSize]="redSize" class="w-100">
  <ng-content></ng-content>

</div>